"use client";

import * as React from "react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
function ProductsConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-lg bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-sm text-muted-foreground py-12">
        No se pudieron cargar los productos.
      </div>;
  }
  if (products.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        No hay productos disponibles en este momento.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:shadow-medium">
          <Link to={product.link}>
            {product.featured_image_url && <div className="aspect-square overflow-hidden bg-muted">
                <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-[1.02]" loading="lazy" />
              </div>}
          </Link>
          <CardHeader>
            <CardTitle className="text-lg font-semibold text-foreground">
              {product.title}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {product.price !== undefined && <div className="flex items-baseline gap-2">
                {product.discounted_price !== undefined && product.discounted_price < product.price ? <>
                    <span className="text-2xl font-bold text-primary">${product.discounted_price.toFixed(2)}</span>
                    <span className="text-sm text-muted-foreground line-through">${product.price.toFixed(2)}</span>
                  </> : <span className="text-2xl font-bold text-foreground">${product.price.toFixed(2)}</span>}
              </div>}
          </CardContent>
          <CardFooter>
            <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-foreground-primary" text="Añadir al carrito" showQuantity={false} />
          </CardFooter>
        </Card>)}
    </div>;
}
export default function Productos() {
  return;
}